<template>
    <v-form>
        <v-container>
            <v-card>
                <v-card-text>
                    <!-- <v-row>
                        <v-col>
                            <p class="text-h6 text--primary">
                                {{ roomName }}
                            </p>
                        </v-col>
                        <v-col>
                            <rate-breakdown :IsPackage="roomRate != null && roomRate.hotDealsType === 'PackageDeal' && mandatoryOptions.length !== 0" :RatePlan="roomRate"></rate-breakdown>
                        </v-col>
                    </v-row> -->
                    <v-row no-gutters class="mx-0 px-0">
                        <v-col cols="12" class="mx-0 px-0">
                            <small>Room Type</small>
                        </v-col>
                        <v-col cols="12" class="mx-0 px-0">
                            <p class="text-h6 font-weight-black text--primary">
                                {{ roomName }}
                            </p>
                        </v-col>

                    </v-row>


                    <v-row no-gutters class="mx-0 px-0">
                        <v-col cols="12" class="mx-0 px-0">
                            <small>Rate Plan</small>
                        </v-col>
                        <v-col cols="12" class="mx-0 px-0">
                            <p class="text-h6">
                                {{ ratePlanName }} <rate-breakdown
                                    :IsPackage="roomRate != null && roomRate.hotDealsType === 'PackageDeal' || roomRate.hotDealsType === 'PayStayDeal'"
                                    :RatePlan="roomRate"></rate-breakdown>
                            </p>
                        </v-col>
                    </v-row>

                    <v-row v-if="hotDealName" no-gutters class="mx-0 px-0">
                        <v-col cols="12" class="mx-0 px-0">
                            <small>Hot Deal</small>
                        </v-col>
                        <v-col cols="12" class="mx-0 px-0">
                            <p class="text-h6">
                                {{ hotDealName }}
                            </p>
                        </v-col>
                    </v-row>


                    <v-row no-gutters class="mx-0 px-0">
                        <v-col cols="12" class="mx-0 px-0">
                            <small>Description</small>
                        </v-col>
                        <v-col cols="12" class="mx-0 px-0">
                            <p class="text--primary">
                                {{ description }}
                            </p>
                        </v-col>
                    </v-row>



                    <!-- <p v-if="roomRate != null && roomRate.hotDealsType === 'PackageDeal' && mandatoryOptions.length !== 0"
                        class="text--primary">{{
                            GetRoomReserve().ratePlan.hotDealDescription
                        }}</p> -->

                        <v-sheet class="grey lighten-2 mb-1 d-flex" height="10" width="822" style="margin-left:-17px;"></v-sheet>

                    <v-container>
                        <p class="font-weight-black">
                            Number of Guest(s)
                        </p>
                        Maximum Occupancy {{ maxAllowedGuest }} person(s)
                        <v-row>
                            <v-col>
                                <p>Adult</p>
                                <v-select v-model="adultSelected" :error="!isValidNumberOfPax"
                                    :error-messages="errorMessages" :items="adultOption" dense solo>
                                </v-select>
                            </v-col>
                            <v-col>
                                <p>Child</p>
                                <v-select v-model="childrenSelected" :error="!isValidNumberOfPax"
                                    :error-messages="errorMessages" :items="childrenOption" dense solo> </v-select>
                            </v-col>
                        </v-row>

                        <!-- FOR RATE PLAN PACKAGE ONLY -->
                        <template
                            v-if="roomRate != null && roomRate.hotDealsType === 'PackageDeal' && mandatoryOptions.length !== 0">
                        <v-sheet class="grey lighten-2 mb-1 d-flex" height="10" width="822" style="margin-left:-28px;"></v-sheet>

                            <v-row>
                                <v-subheader class="text-h6 font-weight-black mx-0">Please Select Item</v-subheader>
                            </v-row>
                            <v-row>
                                Total number of Pax for selected activities must match the total number of Guest(s)
                            </v-row>
                            <v-row>
                                <v-divider></v-divider>
                            </v-row>
                            <v-row>
                                <v-col v-for="(option, ioption) in mandatoryOptions" :key="ioption + 'mandatorySelection'">
                                    <charge-selection :Adult="adultSelected" :Child="childrenSelected"
                                        :Error="!isValidMandatorySelected" :ErrorMessage="errorMessagesMandatorySelection"
                                        :Option="option" @addChargeSelection="addChargeSelection">
                                    </charge-selection>
                                </v-col>
                            </v-row>
                        </template>

                        <v-sheet class="grey lighten-2 mt-1 mb-1" height="10" width="822" style="margin-left:-28px;"></v-sheet>
                        <v-row>
                            <v-subheader class="text-h6 font-weight-black">Add Ons (Optional)</v-subheader>
                        </v-row>
                        <v-row class="mb-2">
                            <v-divider></v-divider>
                        </v-row>
                        <v-row class="mb-2">
                            <v-expansion-panels>
                                <v-expansion-panel v-for="(option, ioption) in optionalOptions"
                                    :key="ioption + 'optionalSelection-row'">
                                    <template v-if="isShowAddOn(option)">
                                        <v-expansion-panel-header>
                                            {{ option.name }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <optional-charge-selection :Option="option" :key="ioption + 'optionalSelection'"
                                                @addChargeSelection="addChargeSelection">
                                            </optional-charge-selection>
                                        </v-expansion-panel-content>
                                    </template>

                                </v-expansion-panel>
                            </v-expansion-panels>

                        </v-row>
                        <v-sheet class="grey lighten-2 mt-1 mb-1" height="10" width="822" style="margin-left:-28px;"></v-sheet>
                        <v-row>
                            <v-subheader class="text-h6 font-weight-black">Select No. of Room/Package to book</v-subheader>
                        </v-row>
                        <v-row>
                            <v-divider></v-divider>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                <v-select v-model="selectedUnit" :items="numberOfUnits" dense solo small-chips>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <!-- <v-alert type="error">
                        I'm an error alert.
                    </v-alert> -->
                <v-card-actions>
                    <v-btn depressed color="error" class="mx-auto" @click="cancelAddCharge">
                        Cancel
                    </v-btn>

                    <v-btn depressed color="primary" class="mx-auto" @click="addRoom('addRoom')"
                        :disabled="!isValidNumberOfPax || !isValidMandatorySelected || GetSubSummaryAjaxing()">
                        add and continue browsing
                    </v-btn>
                    <v-btn depressed color="success" class="mx-auto" @click="addRoom('proceedToPayment')"
                        :disabled="!isValidNumberOfPax || !isValidMandatorySelected || GetSubSummaryAjaxing()">
                        Proceed to payment
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-form>
</template>

<script>

import { mapGetters } from 'vuex'
import ChargeSelection from './ChargeSelection.vue';
import OptionalChargeSelection from './OptionalChargeSelection.vue';
import RateBreakdown from '../RoomRates/RateBreakdown.vue';

import utility from '../../api/utility'
import moment from 'moment';

const roomType = {
    startDate: null,
    endDate: null,
    unit: 0,
    room: {

    },
    ratePlan: {

    },
    services: {

    }
};

export default
    {
        components: {
            ChargeSelection,
            OptionalChargeSelection,
            RateBreakdown
        },
        data() {
            return {
                adultSelected: 1,
                childrenSelected: 0,
                mandatorySelected: [],
                selectedUnit: 1,
                standardGuestIncluded: 0,
                adultPrice: 0,
                childrenPrice: 0,
                maxAllowedGuest: 0,
                adultAddOnOption: 0,
                childAddOnOption: 0,
                childAddOn: 0,
                adultAddOn: 0,
                mandatorySelectedCharges: []
            }
        },
        computed: {
            ...mapGetters(["GetSelectedRoomRate",
                "GetSelectedRoom",
                "GetPropertyInformation",
                "GetRoomReserve",
                "GetExtraServices",
                "GetRoomReserves",
                'GetArrival',
                'GetDeparture',
                'GetSubSummaryAjaxing',
                'GetPromoCode']),
            adultOption: function () {
                let max = this.adultAddOnOption;

                let list = [];

                for (let count = 1; count <= max; count++) {
                    list.push(count)
                }

                return list;
            },
            childrenOption: function () {
                let max = this.childAddOnOption;

                let list = [];

                for (let count = 0; count < max; count++) {
                    list.push(count)
                }

                return list;
            },
            mandatoryOptions: function () {
                return this.GetSelectedRoomRate().mandatorySelectionCharges
            },
            roomRate: function () {
                return { ...this.GetSelectedRoomRate() };
            },
            optionalOptions: function () {
                if(this.roomRate)
                return this.roomRate.optionalSelectionCharges;
                // return this.GetExtraServices();
                return []
            },
            room: function () {
                return { ...this.GetSelectedRoom() };
            },
            propertyInformation: function () {
                return { ...this.GetPropertyInformation() };
            },
            numberOfUnits: function () {
                let occupancy = this.room.availability;

                if (this.roomRate.hotDealsType === 'PayStayDeal' || this.roomRate.hotDealsType === 'PackageDeal') {
                    occupancy = this.roomRate.room.availability;
                }

                let list = [];
                for (let counter = 1; counter <= occupancy; counter++) {
                    list.push({ text: `${counter}`, value: counter });
                }

                return list;
            },
            isValidNumberOfPax: function () {
                let totalPax = this.adultSelected + this.childrenSelected;

                return totalPax <= this.maxAllowedGuest;
            },
            errorMessages: function () {
                if (!this.isValidNumberOfPax) {
                    return [`Please reduce adult or children (${this.maxAllowedGuest} capacity  is allowed)`];
                }
                return []
            },
            errorMessagesMandatorySelection: function () {
                if (!this.isValidMandatorySelected) {
                    let totalPax = this.adultSelected + this.childrenSelected;

                    return [`Please match total selected pax, ${totalPax} total pax selected`];
                }
                return []
            },
            isValidMandatorySelected: function () {
                if (this.roomRate.hotDealsType === 'PackageDeal' && this.mandatoryOptions.length !== 0) {
                    let list = this.mandatorySelectedCharges;
                    let totalPaxMandatorySelected = 0;
                    let totalPax = this.adultSelected + this.childrenSelected;
                    for (let count = 0; count < list.length; count++) {
                        totalPaxMandatorySelected += list[count].pax;
                    }

                    if (totalPax !== totalPaxMandatorySelected) {
                        return false
                    }

                    return true;

                } else {
                    return true;
                }
            },
            roomName: function () {
                if (this.roomRate != null && this.roomRate.hotDealsType === 'PackageDeal' || this.roomRate.hotDealsType === 'PayStayDeal') {
                    return this.roomRate.room.roomName;
                } else {
                    return this.room.roomName;
                }
            },
            description: function () {
                if (this.roomRate != null && this.roomRate.hotDealsType === 'PackageDeal' || this.roomRate.hotDealsType === 'PayStayDeal') {
                    return this.room.hotDealDescription;
                } else {
                    return this.room.description;
                }
            },
            ratePlanName: function () {
                // if (this.roomRate != null && this.roomRate.hotDealsType === 'PackageDeal' && this.mandatoryOptions.length !== 0) {
                //     return this.room.hotDealDescription;
                // } else {
                //     return this.roomRate.rateName;
                // }

                return this.roomRate.rateName;

            },
            hotDealName: function () {
                if (this.roomRate != null && this.roomRate.hotDealsType === 'PackageDeal' || this.roomRate.hotDealsType === 'PayStayDeal') {
                    return this.room.hotDealName;
                }
                return '';
            }
        },
        methods: {
            cancelAddCharge: function () {
                this.$store.dispatch('setActiveScreen', 'room');
            },
            totalMandatorySelectionSelected: function (service, quantity) {
                let list = this.mandatorySelectedCharges;

                let findIndex = list.findIndex(fi => fi.name === service.name);
                if (findIndex > -1) {
                    list[findIndex].pax = quantity
                } else {
                    list.push({ ...service, pax: quantity })
                }

                this.mandatorySelectedCharges = list;
            },
            addChargeSelection: function (service, quantity, isMandatory = false) {
                quantity = Number(quantity);

                if (isMandatory) {
                    this.totalMandatorySelectionSelected(service, quantity);
                }

                let roomReserve = this.GetRoomReserve();
                let services = roomReserve.services;
                let tempServices = services;
                if (services.length !== 0) {
                    let findIndex = services.findIndex(fi => fi.name === service.name);
                    if (findIndex > -1) {
                        if (quantity === 0) {
                            tempServices.splice(findIndex);
                        } else {
                            tempServices[findIndex] = {
                                ...service,
                                quantity: quantity
                            };
                        }

                    } else {
                        if (quantity === 0)
                            return

                        tempServices.push({
                            ...service,
                            quantity: quantity
                        })
                    }
                } else {
                    if (quantity === 0)
                        return

                    tempServices.push({
                        ...service,
                        quantity: quantity
                    })
                }

                let model = {
                    ...roomReserve,
                    services: tempServices
                }
                this.$store.dispatch('setRoomReserve', model);

            },
            addRoom: function (page) {
                let child = this.childrenSelected;
                let adult = this.adultSelected;
                let maxAllowedGuest = this.roomRate.maxAllowedGuest;
                if (maxAllowedGuest < (child + adult)) {

                }

                let payload = {
                    roomTypeId: this.room.beRoomTypeId,
                    roomUnit: this.selectedUnit
                }

                if (this.GetRoomReserve().ratePlan.hotDealsType === 'PackageDeal'
                    || this.GetRoomReserve().ratePlan.hotDealsType === 'PayStayDeal') {
                    payload.roomTypeId = this.GetRoomReserve().ratePlan.room.beRoomTypeId;
                } else {
                    payload.roomTypeId = this.GetRoomReserve().room.beRoomTypeId;
                }

                this.$store.dispatch('deductRoomAvailability', payload);

                let countReserved = this.GetRoomReserves().length;
                for (let counter = 1; counter <= this.selectedUnit; counter++) {
                    this.$store.dispatch('setRoomReserves', {
                        ...this.GetRoomReserve(),
                        id: countReserved + counter,
                        startDate: this.GetArrival(),
                        endDate: this.GetDeparture(),
                        child: child,
                        adult: adult
                    });
                }


                if (page === 'addRoom') {
                    this.$store.dispatch('setActiveScreen', 'room');
                } else if (page === 'proceedToPayment') {
                    this.$store.dispatch('setActiveScreen', 'bookingDetail');
                }


                window.scroll(0, 0);

            },
            getAddOnPaxPrice: async function () {
                try {

                    let pmsRoomTypeId = 0;

                    if (this.roomRate.hotDealsType === 'PackageDeal' || this.roomRate.hotDealsType === 'PayStayDeal') {
                        pmsRoomTypeId = this.roomRate.room.pmsRoomTypeId;
                    } else {
                        pmsRoomTypeId = this.room.pmsRoomTypeId;

                    }

                    let body = {
                        adult: this.adultSelected,
                        child: this.childrenSelected,
                        beRatePlanId: this.roomRate.ratePlanId,
                        totalNight: this.roomRate.priceList.length,
                        promotionType: this.roomRate.promotionType,
                        promoDiscount: this.roomRate.promoDiscount,
                        startDate: this.GetArrival(),
                        endDate: this.GetDeparture(),
                        pmsRoomTypeId: pmsRoomTypeId,
                        promoCode: this.GetPromoCode()
                    }
                    let res = await utility.getAddOnPaxPrice(body);
                    if (res.data.success) {
                        this.childrenPrice = res.data.data.childPrice;
                        this.adultPrice = res.data.data.adultPrice;
                        this.adultAddOn = res.data.data.adult;
                        this.childAddOn = res.data.data.child;
                    }


                } catch (error) {
                    console.log(error)
                }
            },
            childrenComputation: async function () {
                let data = this.GetSelectedRoomRate().addOnPaxChildrens.find(a => a.occupancy === this.childrenSelected);
                await this.getAddOnPaxPrice();

                // let quantity = this.childrenSelected;
                let quantity = this.childAddOn;
                let roomReserve = this.GetRoomReserve();
                let services = roomReserve.services;
                let tempServices = services;
                let service = {
                    name: "Extra Child",
                    displayPrice: "",
                    description: '',
                    amount: this.childrenPrice,
                    id: 0
                }

                if (services.length !== 0) {
                    let findIndex = services.findIndex(fi => fi.name === service.name);
                    if (findIndex > -1) {
                        if (this.childrenPrice === 0) {
                            tempServices.splice(findIndex);
                        } else {
                            tempServices[findIndex] = {
                                ...service,
                                quantity: quantity
                            };
                        }


                    } else {
                        if (this.childrenPrice !== 0)
                            tempServices.push({
                                ...service,
                                quantity: quantity
                            })
                    }
                } else {
                    if (this.childrenPrice !== 0)
                        tempServices.push({
                            ...service,
                            quantity: quantity
                        })
                }

                let model = {
                    ...roomReserve,
                    services: tempServices
                }

                this.$store.dispatch('setRoomReserve', model);

            },
            adultComputation: async function () {
                await this.getAddOnPaxPrice();
                let data = this.GetSelectedRoomRate().addOnPaxAdults.find(a => a.occupancy === this.adultSelected);
                // let quantity = this.adultSelected;
                let quantity = this.adultSelected - this.standardGuestIncluded;
                let roomReserve = this.GetRoomReserve();
                let services = roomReserve.services;
                let tempServices = services;
                let service = {
                    name: "Extra Adult",
                    displayPrice: "",
                    description: '',
                    amount: this.adultPrice,
                    id: 0
                }

                if (services.length !== 0) {
                    let findIndex = services.findIndex(fi => fi.name === service.name);
                    if (findIndex > -1) {
                        if (this.adultPrice === 0) {
                            tempServices.splice(findIndex);
                        } else {
                            tempServices[findIndex] = {
                                ...service,
                                quantity: quantity
                            };
                        }


                    } else {
                        if (this.adultPrice !== 0)
                            tempServices.push({
                                ...service,
                                quantity: quantity
                            })
                    }
                } else {
                    if (this.adultPrice !== 0)
                        tempServices.push({
                            ...service,
                            quantity: quantity
                        })
                }

                let model = {
                    ...roomReserve,
                    services: tempServices
                }

                this.$store.dispatch('setRoomReserve', model);
            },
            isShowAddOn: function (item) {
                let arrival = this.GetArrival();
                let departure = this.GetDeparture();

                let offerEndDate = moment(item.offerEndDate).format('YYYY-MM-DD');

                let offerStartDate = moment(item.offerStartDate).format('YYYY-MM-DD');

                if (item.offerEndDate === '' && item.offerStartDate === '') {
                    return true;
                }

                if (arrival >= offerStartDate && departure <= offerEndDate) {
                    return true;
                }

                if ((arrival >= offerStartDate && arrival <= offerEndDate) || (departure >= offerStartDate && departure <= offerEndDate)) {
                    return true;
                }

                return false;

            }
        },
        mounted: function () {
            this.adultSelected = this.GetSelectedRoomRate().standardGuestIncluded;
            this.standardGuestIncluded = this.GetSelectedRoomRate().standardGuestIncluded;
            this.maxAllowedGuest = this.GetSelectedRoomRate().maxAllowedGuest
            this.adultAddOnOption = this.GetSelectedRoomRate().addOnPaxAdults.length
            this.childAddOnOption = this.GetSelectedRoomRate().addOnPaxChildrens.length
            let model = {
                room: this.room,
                ratePlan: this.roomRate,
                services: []
            }

            model.room.roomRatePlans = null;

            this.$store.dispatch('setRoomReserve', model);
            window.scroll(0, 0);
        },
        watch: {
            adultSelected: async function (newData, oldData) {
                if (oldData !== null) {
                    await this.adultComputation()
                    await this.childrenComputation()
                }
            },

            childrenSelected: async function (newData, oldData) {
                if (oldData !== null) {
                    await this.childrenComputation()
                    await this.adultComputation();
                }
            }
        }
    }
</script>
